import { Box } from "@mui/material"

type Props = {
    code: string
    color?: string
}

export const DocumentTypeCodeBadge = ({ code, color }: Props) => {
    return (
        <Box
            sx={{
                width: 40,
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 1,
                fontWeight: 700,
                fontSize: 12,
                color: "white",
                backgroundColor: color || "#888",
                textTransform: "uppercase",
                letterSpacing: 1,
                px: 0.5,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
            }}
        >
            {code}
        </Box>
    )
}
